// eslint-disable-next-line import/prefer-default-export
export const autocompleteAddressMock = async (): Promise<any> => {
  const response = {
    count: 7,
    results: [
      {
        suggestion: '200 George Street, BATHURST  NSW 2795',
        matched: [],
        format: 'https://api.edq.com/capture/address/v2/format?country=AUS&id=aWQ9MjAwIEdlb3JnZSBTdHJlZXQsIEJBVEhVUlNUICBOU1cgMjc5NSwgQXVzdHJhbGlhfmFsdF9rZXk9ODYyMDIzMjF-ZGF0YXNldD1BVVNfUEFGfmZvcm1hdGlkPTc2MkFVUy1hT0FVU0hBYmxCd0FBQUFBSUFnRUFBQUFBRFdSa3dBQUFBQUFBQURJd01BQUEuLjlrQUFBQUFQLi4uLjhBQUFBQUFBQUFBQUFBQUFBQUFBQXlNREFnWjJWdmNnQUFBQUFBfnFsPTh-Z2VvPTA'
      },
      {
        suggestion: '200 George Street, CONCORD WEST  NSW 2138',
        matched: [],
        format: 'https://api.edq.com/capture/address/v2/format?country=AUS&id=aWQ9MjAwIEdlb3JnZSBTdHJlZXQsIENPTkNPUkQgV0VTVCAgTlNXIDIxMzgsIEF1c3RyYWxpYX5hbHRfa2V5PTg3NjA5MTM5fmRhdGFzZXQ9QVVTX1BBRn5mb3JtYXRpZD03NjJBVVMtMU9BVVNIQWJsQndBQUFBQUlBZ0VBQUFBQUlKTVVRQUFBQUFBQUFESXdNQUFBLi45a0FBQUFBUC4uLi44QUFBQUFBQUFBQUFBQUFBQUFBQUF5TURBZ1oyVnZjZ0FBQUFBQX5xbD04fmdlbz0w'
      },
      {
        suggestion: '200 George Street, EAST MAITLAND  NSW 2323',
        matched: [],
        format: 'https://api.edq.com/capture/address/v2/format?country=AUS&id=aWQ9MjAwIEdlb3JnZSBTdHJlZXQsIEVBU1QgTUFJVExBTkQgIE5TVyAyMzIzLCBBdXN0cmFsaWF-YWx0X2tleT05NTY4MTk4N35kYXRhc2V0PUFVU19QQUZ-Zm9ybWF0aWQ9NzYyQVVTLWlPQVVTSEFibEJ3QUFBQUFJQWdFQUFBQUFLWFFsZ0FBQUFBQUFBREl3TUFBQS4uOWtBQUFBQVAuLi4uOEFBQUFBQUFBQUFBQUFBQUFBQUFBeU1EQWdaMlZ2Y2dBQUFBQUF-cWw9OH5nZW89MA'
      },
      {
        suggestion: '200 George Street, PARRAMATTA  NSW 2150',
        matched: [],
        format: 'https://api.edq.com/capture/address/v2/format?country=AUS&id=aWQ9MjAwIEdlb3JnZSBTdHJlZXQsIFBBUlJBTUFUVEEgIE5TVyAyMTUwLCBBdXN0cmFsaWF-YWx0X2tleT03MDYxNTkzOX5kYXRhc2V0PUFVU19QQUZ-Zm9ybWF0aWQ9NzYyQVVTLWdPQVVTSEFibEJ3QUFBQUFJQWdFQUFBQUFXY2JPRUFBZ0FBQUFBQUFBQUFELi4yUUFBQUFBLi4uLi53QUFBQUFBQUFBQUFBQUFBQUFBQURJd01DQm5aVzl5QUFBQUFBQS1-cWw9OH5nZW89MA'
      },
      {
        suggestion: '200 George Street, SYDNEY  NSW 2000',
        matched: [],
        format: 'https://api.edq.com/capture/address/v2/format?country=AUS&id=aWQ9MjAwIEdlb3JnZSBTdHJlZXQsIFNZRE5FWSAgTlNXIDIwMDAsIEF1c3RyYWxpYX5hbHRfa2V5PTQxOTE4NTY4fmRhdGFzZXQ9QVVTX1BBRn5mb3JtYXRpZD03NjJBVVMtYk9BVVNIQWJsQndBQUFBQUlBZ0VBQUFBQWEudFdrQUFnQUFBQUFBQUFBQUQuLjJRQUFBQUEuLi4uLndBQUFBQUFBQUFBQUFBQUFBQUFBREl3TUNCblpXOXlBQUFBQUFBLX5xbD04fmdlbz0w'
      },
      {
        suggestion: 'Ground Floor  200 George Street, SYDNEY  NSW 2000',
        matched: [],
        format: 'https://api.edq.com/capture/address/v2/format?country=AUS&id=aWQ9R3JvdW5kIEZsb29yICAyMDAgR2VvcmdlIFN0cmVldCwgU1lETkVZICBOU1cgMjAwMCwgQXVzdHJhbGlhfmFsdF9rZXk9NjQyMTc4OTN-ZGF0YXNldD1BVVNfUEFGfmZvcm1hdGlkPTc2MkFVUy1WT0FVU0hBYmxCd0FBQUFBSUFnRUFBQUFBYS50WlVCQWhBSUlBQUFBQUFBQUFBQUQuLjJRQUFBQUEuLi4uLndBQUFBQUFBQUFBQUFBQUFBQUFBREl3TUNCblpXOXlBQUFBQUFBLX5xbD04fmdlbz0w'
      },
      {
        suggestion: 'Level 1  200 George Street, SYDNEY  NSW 2000',
        matched: [],
        format: 'https://api.edq.com/capture/address/v2/format?country=AUS&id=aWQ9TGV2ZWwgMSAgMjAwIEdlb3JnZSBTdHJlZXQsIFNZRE5FWSAgTlNXIDIwMDAsIEF1c3RyYWxpYX5hbHRfa2V5PTM0MDg5NjcwfmRhdGFzZXQ9QVVTX1BBRn5mb3JtYXRpZD03NjJBVVMtT09BVVNIQWJsQndBQUFBQUlBZ0VBQUFBQWEudGJVQWdnQUFBQUFBQUFNUUFBLi45a0FBQUFBUC4uLi44QUFBQUFBQUFBQUFBQUFBQUFBQUF5TURBZ1oyVnZjZ0FBQUFBQX5xbD04fmdlbz0w'
      }
    ]
  };
  return new Promise((resolve, _reject) => {
    resolve(response);
  });
};

export const captureAddressMock = async (): Promise<any> => {
  const response = {
    address: [
      { addressLine1: '2000 George Downes Dr' },
      { addressLine2: '' },
      { addressLine3: '' },
      { locality: 'KULNURA' },
      { province: 'NSW' },
      { postalCode: '2250' },
      { country: 'AUSTRALIA' }
    ],
    components: [
      { deliveryPointId1: '85166298' },
      { streetNumber1: '2000' },
      { street1: 'George Downes Dr' },
      { locality1: 'KULNURA' },
      { province1: 'New South Wales' },
      { provinceCode1: 'NSW' },
      { postalCode1: '2250' },
      { country1: 'AUSTRALIA' },
      { countryISO1: 'AUS' }
    ],
    metadata: { addressIds: { dpid: '85166298' } }
  };
  return new Promise((resolve, _reject) => {
    resolve(response);
  });
};
